import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowsInSimpleSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M16.0649 1.51163L13.7355 3.83222L15.3591 5.44693C15.4548 5.54899 15.5197 5.67607 15.5463 5.81348C15.5728 5.95089 15.5599 6.09301 15.5091 6.2234C15.4551 6.35187 15.3642 6.46148 15.248 6.53842C15.1318 6.61536 14.9955 6.65618 14.8561 6.65575H10.6208C10.4336 6.65575 10.2541 6.58138 10.1217 6.449C9.98931 6.31662 9.91494 6.13708 9.91494 5.94987V1.71457C9.9145 1.57521 9.95533 1.43884 10.0323 1.32265C10.1092 1.20645 10.2188 1.11563 10.3473 1.06163C10.4777 1.01078 10.6198 0.997874 10.7572 1.02442C10.8946 1.05096 11.0217 1.11587 11.1238 1.21163L12.7385 2.83516L15.0591 0.505749C15.1962 0.393187 15.3703 0.335663 15.5475 0.344367C15.7247 0.353071 15.8924 0.427379 16.0178 0.552839C16.1433 0.678299 16.2176 0.845939 16.2263 1.02315C16.235 1.20037 16.1775 1.37448 16.0649 1.51163ZM6.38553 9.47928H2.15023C2.01087 9.47884 1.8745 9.51967 1.75831 9.59661C1.64211 9.67355 1.55129 9.78316 1.49729 9.91163C1.44644 10.042 1.43353 10.1841 1.46008 10.3215C1.48662 10.459 1.55153 10.586 1.64729 10.6881L3.27082 12.3028L0.941409 14.6234C0.808857 14.7572 0.734497 14.938 0.734497 15.1263C0.734497 15.3147 0.808857 15.4954 0.941409 15.6293C1.07633 15.7597 1.25667 15.8327 1.44435 15.8327C1.63203 15.8327 1.81237 15.7597 1.94729 15.6293L4.26788 13.2999L5.88259 14.9234C6.01808 15.0529 6.19809 15.1255 6.38553 15.1263C6.47921 15.1259 6.57199 15.108 6.65906 15.0734C6.78753 15.0194 6.89714 14.9286 6.97408 14.8124C7.05102 14.6962 7.09184 14.5598 7.09141 14.4205V10.1852C7.09141 9.99795 7.01704 9.8184 6.88466 9.68603C6.75228 9.55365 6.57274 9.47928 6.38553 9.47928Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowsInSimpleSvg };
